import "./homepage_styles/top_navbar.css"



export default function Top_navbar () {



    return (
        <div>

        <ul id="topnav">
            <li>STOCKS</li>
            <li>NEWS</li>
            <li>FORECAST</li>
        </ul>

        </div>
    )
}